/* hc-bcar.js - script de sections/benefits-carousel.liquid, externalise le 19-08-2026 (defer). */
document.addEventListener('DOMContentLoaded', function () {
  const track = document.querySelector('.helps-with-carousel__track');

  if (track) {
    const trackContainer = document.querySelector('.helps-with-carousel__track-container');
    const items = document.querySelectorAll('.helps-with-carousel__item');

    let totalWidth = 0;
    const firstSetItems = Array.from(items).slice(0, items.length / 3);
    firstSetItems.forEach(item => {
      totalWidth += item.offsetWidth + parseInt(getComputedStyle(item).marginLeft) + parseInt(getComputedStyle(item).marginRight);
    });

    if (totalWidth < trackContainer.offsetWidth) {
      track.style.animation = 'none';
      track.style.justifyContent = 'center';
    }
  }
});